export type LiveSourceType = "direct" | "youtube" | "external" | "offline";

export interface LiveControlSettings {
  id: string;
  sourceType: LiveSourceType;
  hlsUrl: string;
  youtubeUrl: string;
  externalUrl: string;
  liveTitle: string;
  liveDescription: string;
  currentPresenter: string;
  currentProgram: string;
  nextProgram: string;
  thumbnail: string;
  startTime: string;
  endTime: string;
  offlineMessage: string;
}

export const liveSourceOptions: { value: LiveSourceType; label: string; hint: string; icon: string }[] = [
  {
    value: "direct",
    label: "Direct L+TV Stream",
    hint: "Play an HLS (.m3u8) feed from your studio/control room via a streaming server or CDN.",
    icon: "ri-broadcast-line",
  },
  {
    value: "youtube",
    label: "YouTube Live",
    hint: "Embed a YouTube Live broadcast using its URL or video ID.",
    icon: "ri-youtube-line",
  },
  {
    value: "external",
    label: "External Stream",
    hint: "Use another supported streaming provider's compatible stream URL.",
    icon: "ri-link",
  },
  {
    value: "offline",
    label: "Offline",
    hint: "No stream is active. Viewers see a professional offline screen.",
    icon: "ri-stop-circle-line",
  },
];

export const liveControlSeed: LiveControlSettings = {
  id: "live-control",
  sourceType: "offline",
  hlsUrl: "",
  youtubeUrl: "",
  externalUrl: "",
  liveTitle: "L+TV LIVE",
  liveDescription:
    "L+TV is currently preparing its live broadcast. Please check back soon or browse our programs and videos.",
  currentPresenter: "L+TV Broadcast Team",
  currentProgram: "Preparing for Broadcast",
  nextProgram: "L+TV News Hour at 18:00",
  thumbnail: "",
  startTime: "",
  endTime: "",
  offlineMessage: "We are currently offline. Please check back soon for our next live broadcast.",
};